import { Clock, FileText, Plus, Minus, BookOpen, PlayCircle, CheckCircle2 } from 'lucide-react';
import { useState } from 'react';

const COURSE = {
  curriculum: [
    'Understanding E-Commerce Platforms',
    'Documentation Requirements',
    'Seller Account Registration Process',
    'Shipping Settings Configuration',
  ],
};

export default function CourseCurriculum() {
  const [expandedItems, setExpandedItems] = useState({ 0: true });

  const toggleExpand = (index) => {
    setExpandedItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-8">
        <h2 className="text-2xl font-black text-slate-900 flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-orange-100 flex items-center justify-center text-orange-600">
            <BookOpen size={20} />
          </div>
          Course Curriculum
        </h2>
        <div className="text-xs font-bold text-slate-400 uppercase tracking-widest bg-slate-50 px-3 py-1.5 rounded-full border border-slate-100">
          {COURSE.curriculum.length} Modules • 12h 30m Total
        </div>
      </div>
      
      <div className="space-y-4">
        {COURSE?.curriculum?.map((item, index) => {
          const isExpanded = expandedItems[index];
          return (
            <div 
              key={index} 
              className={`group border transition-all duration-300 rounded-[24px] overflow-hidden ${
                isExpanded 
                  ? 'border-orange-200 bg-white shadow-xl shadow-orange-500/5' 
                  : 'border-slate-100 bg-slate-50/50 hover:border-slate-200 hover:bg-white'
              }`}
            >
              <div 
                className="flex items-center justify-between p-5 sm:p-6 cursor-pointer"
                onClick={() => toggleExpand(index)}
              >
                <div className="flex items-center gap-4 flex-1 min-w-0">
                  <div className={`w-10 h-10 flex items-center justify-center rounded-xl font-black text-sm transition-all ${
                    isExpanded ? 'bg-orange-600 text-white shadow-lg shadow-orange-200' : 'bg-white text-slate-400 shadow-sm'
                  }`}>
                    {String(index + 1).padStart(2, '0')}
                  </div>
                  <div className="flex flex-col gap-0.5">
                    <span className={`font-bold transition-colors text-sm sm:text-base ${
                      isExpanded ? 'text-orange-600' : 'text-slate-700 group-hover:text-slate-900'
                    }`}>
                      {item}
                    </span>
                    <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">
                      Module {index + 1} • 4 Lessons
                    </span>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className={`p-2 rounded-lg transition-all ${
                    isExpanded ? 'bg-orange-100 text-orange-600' : 'bg-slate-200/50 text-slate-400'
                  }`}>
                    {isExpanded ? <Minus className="w-5 h-5" /> : <Plus className="w-5 h-5" />}
                  </div>
                </div>
              </div>
              
              {isExpanded && (
                <div className="px-6 pb-6 pt-2">
                  <div className="bg-slate-50/80 rounded-2xl p-5 space-y-4">
                    <div className="space-y-3">
                      {[1, 2, 3].map((lesson) => (
                        <div key={lesson} className="flex items-center justify-between group/lesson cursor-pointer">
                          <div className="flex items-center gap-3">
                            <div className="w-8 h-8 rounded-lg bg-white flex items-center justify-center text-slate-400 group-hover/lesson:text-orange-500 shadow-sm transition-colors">
                              <PlayCircle size={16} />
                            </div>
                            <span className="text-xs sm:text-sm font-medium text-slate-600 group-hover/lesson:text-slate-900">
                              {lesson === 1 ? 'Introduction & Setup' : lesson === 2 ? 'Core Concepts' : 'Practical Exercise'}
                            </span>
                          </div>
                          <div className="flex items-center gap-3">
                            <span className="text-[10px] font-bold text-slate-400">15:00</span>
                            <CheckCircle2 size={14} className="text-slate-200 group-hover/lesson:text-emerald-500 transition-colors" />
                          </div>
                        </div>
                      ))}
                    </div>
                    
                    <div className="pt-4 border-t border-slate-200/50 flex flex-wrap items-center gap-4">
                      <div className="flex items-center gap-2 text-[10px] font-bold text-slate-500 uppercase tracking-wider">
                        <Clock className="w-3.5 h-3.5 text-orange-500" />
                        45 Mins Total
                      </div>
                      <div className="flex items-center gap-2 text-[10px] font-bold text-slate-500 uppercase tracking-wider">
                        <FileText className="w-3.5 h-3.5 text-blue-500" />
                        3 Resources
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}